module.exports = {
	"failed": "Het inloggen is mislukt",
	"success": "Het inloggen is geslaagd"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/fi/auth.json
// module id = 514
// module chunks = 1